/* eslint-disable react/prop-types */
import React from 'react';
import { host } from '../../helpers/url';
import config from '../../../config/config';

export default props => {
  const href = config.isDevelopment ? `${host()}/${props.to}` : `/${props.to}`;

  return (
    <a href={href} {...props}>
      {props.children}
    </a>
  );
};
